const messages = {
    accountBox: {
        title: "Табло за управление",
        description: "Следете бързо своите промоции и точки.",
        button: "ОТВОРИ ТАБЛОТО",
    },
};

export default {
    messages,
};
